module.exports = __webpack_public_path__ + "media/images/activate/capterra-b9fa3d63107ea2cfe13d63984e88d52e.png";